/**
 * @module FieldControls
 */
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { defaultLocalization } from "./localization.js";
/**
 * Field control that represents a Choice field. Available values will be populated from the FieldSettings.
 */
export const RadioButtonGroup = props => {
  var _props$localization;
  const localization = deepMerge(defaultLocalization.radioButtonGroup, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.radioButtonGroup);
  const getInitialState = () => {
    if (!props.fieldValue) {
      var _props$settings$Defau;
      return props.actionName === 'new' ? (_props$settings$Defau = props.settings.DefaultValue) !== null && _props$settings$Defau !== void 0 ? _props$settings$Defau : '' : '';
    }
    return Array.isArray(props.fieldValue) ? props.fieldValue[0] : props.fieldValue;
  };
  const [value, setValue] = useState(getInitialState);
  const handleChange = (_event, changedValue) => {
    var _props$fieldOnChange;
    setValue(changedValue);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, Array.isArray(changedValue) ? changedValue : [changedValue]);
  };
  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(FormControl, {
        component: 'fieldset',
        fullWidth: true,
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly
      }, /*#__PURE__*/React.createElement(FormLabel, {
        style: {
          transform: 'translate(0, 1.5px) scale(0.75)',
          transformOrigin: 'top left'
        }
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(RadioGroup, {
        "aria-label": props.settings.DisplayName,
        name: props.settings.Name,
        value: value,
        onChange: handleChange
      }, props.settings.Options && props.settings.Options.map(option => {
        return /*#__PURE__*/React.createElement(FormControlLabel, {
          key: option.Value,
          value: option.Value,
          control: /*#__PURE__*/React.createElement(Radio, null),
          label: option.Text
        });
      })), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description));
    case 'browse':
    default:
      {
        var _props$settings$Optio, _props$settings$Optio2, _props$settings$Optio3;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          gutterBottom: true
        }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          gutterBottom: true
        }, value ? (_props$settings$Optio = (_props$settings$Optio2 = props.settings.Options) === null || _props$settings$Optio2 === void 0 ? void 0 : (_props$settings$Optio3 = _props$settings$Optio2.find(item => item.Value === value)) === null || _props$settings$Optio3 === void 0 ? void 0 : _props$settings$Optio3.Text) !== null && _props$settings$Optio !== void 0 ? _props$settings$Optio : value : localization.noValue));
      }
  }
};
//# sourceMappingURL=radio-button-group.js.map